var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconGen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.603,
    height: 15.509
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".icon_gen_svg__a{fill:none;stroke:#797979;stroke-miterlimit:10}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "icon_gen_svg__a",
    d: "M4.62 15.01a2.789 2.789 0 01-2.695-2.074L.535 7.689a.891.891 0 01.862-1.119h6.441A.891.891 0 018.7 7.689l-1.386 5.247A2.793 2.793 0 014.62 15.01zM10.186 14.747h7.77l-1.719-6.509a2.237 2.237 0 00-4.325 0zM14.068 4.944a2.222 2.222 0 112.218-2.222 2.225 2.225 0 01-2.222 2.222zM4.618 4.965a2.222 2.222 0 112.224-2.218 2.225 2.225 0 01-2.224 2.218z"
  })));
}
export default __webpack_public_path__ + "static/media/icon_gen.2a39f26a.svg";
export { SvgIconGen as ReactComponent };